import { combineReducers, Reducer } from 'redux';

import * as types from './company-tools-categories.types';
import * as constants from './company-tools-categories.constants';
import { isActionOfType } from '../../../../utils/action.utils';

const initialState: types.ICompanyToolsCategoriesPageState = {
  companyToolsCategoryIds: [],
};

const companyToolsCategoriesReducer: Reducer<
  types.ICompanyToolsCategoriesPageState['companyToolsCategoryIds'],
  types.IStoreCompanyToolsCategories | types.IClearCompanyToolsCategories
> = (state = initialState.companyToolsCategoryIds, action) => {
  if (isActionOfType<types.IStoreCompanyToolsCategories>(action, constants.STORE_COMPANY_TOOLS_CATEGORIES)) {
    return action.payload;
  } else if (isActionOfType<types.IClearCompanyToolsCategories>(action, constants.CLEAR_COMPANY_TOOLS_CATEGORIES)) {
    return initialState.companyToolsCategoryIds;
  }

  return state;
};

export const companyToolsCategoriesPageReducer: Reducer<
  types.ICompanyToolsCategoriesPageState,
  types.ICompanyToolsCategoriesPageAction
> = combineReducers({
  companyToolsCategoryIds: companyToolsCategoriesReducer,
});
